/**
 * Created by linjianxi on 2016/11/10.
 */
import * as http from '../../../utils/common'
import * as types from './mutation-type'
import cookie from '../../../utils/cookie'

/**
 * 获取充值列表
 * @param commit
 * @param params
 */
export const payList = ({commit}, params) => {
  http.post({
    url: '/LVBpages/api/ApiActivity/GetPayPageInfo',
    data: params.data,
    succ: function (res) {
      if (res.result === 1) {
        // console.log(res)
        commit(types.PAY_LIST, res.data)
      } else {
        alert(res.message)
      }
    }
  }, params._this.$store.commit)
}

/**
 * 微信支付
 * @param commit
 * @param params
 */
export const wechatPay = ({commit}, params) => {
  http.post({
    url: '/LVBpages/api/ApiPay/CreateOrderInfoWeixin',
    data: params.data,
    succ: function (res) {
      if (res.result === 1) {
        console.log('weixin://wap/pay?appid=' + res.data.appid + '&noncestr=' + res.data.noncestr + '&package=' + 'WAP' + '&prepayid=' + res.data.prepayid + '&sign=' + res.data.sign + '&timestamp=' + res.data.timestamp)
        window.location.href = 'weixin://wap/pay?appid=' + res.data.appid + '&noncestr=' + res.data.noncestr + '&package=' + 'WAP' + '&prepayid=' + res.data.prepayid + '&sign=' + res.data.sign + '&timestamp=' + res.data.timestamp
        /* wx.config({
         debug: true,
         appId: res.data.appid,
         timestamp: res.data.timestamp,
         nonceStr: res.data.noncestr,
         signature: res.data.sign,
         jsApiList: ['chooseWXPay']
         })
         wx.ready(function () {
         wx.chooseWXPay({
         timestamp: res.data.timestamp,
         nonceStr: res.data.noncestr,
         package: res.data.package,
         signType: 'MD5',
         paySign: res.data.sign,
         success: function (succRes) {
         weiXinCB(commit, succRes)
         },
         fail: function () {
         }
         })
         })
         wx.error(function (errRes) {
         console.log(errRes)
         }) */
      } else {
        alert(res.message)
      }
    }
  }, params._this.$store.commit)
}

/**
 * 微信：完成支付后回调接口（更新订单状态和返回用户钻石余额）
 * @param commit
 * @param params
 */
export const weiXinCB = (commit, params) => {
  http.post({
    url: '/LVBpages/api/ApiPay/PayCallBackWeixin',
    data: {result_status: params.result_status, result: params.result},
    succ: function (res) {
      if (res.result === 1) {
        // console.log(res)
        commit(types.WECHART_PAY, res.data)
      } else {
        alert(res.message)
      }
    }
  })
}

/**
 * 支付宝支付
 * @param commit
 * @param params
 */
export const aliPay = ({commit}, params) => {
  http.post({
    url: '/LVBpages/api/ApiPay/CreateOrderInfoAliForPC',
    data: params.data,
    succ: function (res) {
      if (res.result === 1) {
        // console.log(res)
        gateway(commit, res.data)
        // commit(types.ALIPAY_HTML, {html_form_info: res.data.html_form_info, _this: params._this})
      } else {
        alert(res.message)
      }
    }
  }, params._this.$store.commit)
}

/**
 * 调用支付宝接口
 * @param commit
 * @param params
 */
/* eslint-disable */
export const gateway = ({commit}, params) => {
  // console.log(params.orderinfo.replace(/"/g,''))
  window.location.href = params.html_form_info
  /*$.ajax({
   type: 'GET',
   url: 'https://mapi.alipay.com/gateway.do?' + params.orderinfo,
   success: function (res) {
   if (res.result === 1) {
   console.log(res)
   alipayCB(commit, res.data)
   } else {
   console.log(res)
   }
   }
   })*/
  /* http.post({
   url: '/LVBpages/api/ApiPay/POSTAliOrderinfo?' + params.orderinfo,
   data: {},
   succ: function (res) {
   if (res.result === 1) {
   console.log(res)
   alipayCB(commit, res.data)
   } else {
   alert(res.message)
   }
   }
   }) */
}
/**
 * 支付宝：完成支付后回调接口（更新订单状态和返回用户钻石余额）
 * @param commit
 * @param params
 */
export const alipayCB = (commit, params) => {
  http.post({
    url: '/LVBpages/api/ApiPay/PayCallBackAli',
    data: {out_trade_no: params.out_trade_no, result_status: '200', result: ''},
    succ: function (res) {
      if (res.result === 1) {
        console.log(res)
      } else {
        alert(res.message)
      }
    }
  })
}

/**
 * 获取用户信息
 * @param commit
 * @param params
 */
export const getUserInfo = ({commit}, params) => {
  http.post({
    url: '/LVBpages/api/ApiPay/GetUserInfo',
    data: params.data,
    succ: function (res) {
      if (res.result === 1) {
        // console.log(res)
        cookie('isUserCookie', true)
        params._this.isUserCookie = true
        params._this.isSelUse = true
        cookie('avatarurl', res.data.avatar_url)
        cookie('nickname', res.data.nickname)
        cookie('emid',res.data.emid)
        cookie('id',res.data.id)
        params._this.avatar_url = res.data.avatar_url
        params._this.nickname = res.data.nickname
        params._this.emid = res.data.emid
        commit(types.USER_INFOR, res.data)
        // commit(types.GET_CODE_IMG, res.data)
      } else {
        commit(types.GET_CODE_IMG, '/LVBPages/Api/VerifyCode/GetVerifyCode?reqtype=Server&vcodeTarget=eastmoney')
        // alert(res.message)
      }
    }
  })
}

/**
 * 跟新验证码
 * @param commit
 */
export const refreshCode = ({commit}) => {
  commit(types.GET_CODE_IMG, '/LVBPages/Api/VerifyCode/GetVerifyCode?reqtype=Server&vcodeTarget=eastmoney&time=' + Date.parse(new Date()))
}

/**
 * 切换用户
 * @param commit
 */
export const swichUser = ({commit}, params) => {
  cookie('isUserCookie', false)
  params._this.isUserCookie = false
  commit(types.SWITCH_USER)
}





// WEBPACK FOOTER //
// ./src/vuex/modules/recharge/actions.js